import { post } from '~/plugins/nikan-api'
import Endpoints from '@nikan/endpoints'
import _ from 'lodash'

const KEYS = {
  REPLACE_ALL: 'replaceAll'
}

export const state = {
  items: [],
  todayRates: []
}

export const mutations = {
  [KEYS.REPLACE_ALL](state, items) {
    state.items = [].concat(items)
  }
}

export const actions = {
  refresh({ state, commit }, options) {
    return new Promise((resolve, reject) => {
      options = _.merge({ force: false }, options)

      if (options.force !== true) {
        if (state.items.length) {
          resolve(state.items)
          return
        }
      }

      post(Endpoints.getUrl('companies.getCurrencies'), { preventConcurrent: false })
        .then(result => {
          if (result.success) {
            commit(KEYS.REPLACE_ALL, result.data.items)
            resolve(result.data)
          }
        })
        .catch(error => reject(error))
    })
  },
  refreshTodayRates({ state, commit }) {
    post(Endpoints.getUrl('general.get-today'), null, null, { preventConcurrent: false })
      .then(today => {
        var request = {
          date: `${today.data.gregorianYear}-${today.data.gregorianMonth}-${today.data.gregorianDay}`
        }
        post(Endpoints.getUrl('currencyRate.list'), request, null, { preventConcurrent: false })
          .then(result => {
            state.todayRates = result.data.items
          })
      })
  }
}

export const getters = {
  companyCurrencies: state => state.items,
  todayRates: state => state.todayRates,
  hasMultiCurrency: state => state.items.filter((x) => x.isEnabled).length > 1,
  getCurrency: state => (id) => {
    return state.items.find(x => x.id === id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
